<template>
	<form class="form form--login login-form" ref="form" @submit.prevent.stop="submitForm(fields)">
		<div class="form-section">
			<div class="form-row">
				<TextField class="form__field" id="email" v-model="fields.email" label="Email Address" type="email" autocomplete="email" autofocus :required="true" />
				<TextField class="form__field" id="password" v-model="fields.password" label="Password" type="password" :required="true" />
			</div>

			<div class="form__message error" v-if="errorMessage">
				{{ errorMessage }}
			</div>

			<div class="form__actions form__actions--horizontal">
				<Button type="submit" look="form" :disabled="isLoading || !$refs.form?.checkValidity()" :loading="isLoading">Log In</Button>
				<Button type="button" look="text" :disabled="isLoading" @click.prevent.stop="resetPassword(fields)">Reset Password</Button>
			</div>
		</div>
	</form>
</template>

<script>
import Button from '@/components/Button.vue'
import TextField from '@/components/TextField.vue'

import { useUserStore } from '@/lib/store/user'

export default {
	name: 'LoginForm',
	components: {
		Button,
		TextField,
	},
	setup() {
		const userStore = useUserStore()

		return {
			userStore,
		}
	},
	props: {
		redirect: {
			type: Boolean,
			default: true,
		},
		checkout: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		fields: {},
		errorMessage: null,
	}),
	computed: {
		isLoading() {
			return this.userStore.isLoading
		}
	},
	methods: {
		submitForm(fields) {
			this.errorMessage = null
			if (this.checkout) {
				this.userStore.loginRemote(fields)
					.catch(error => {
						this.errorMessage = error.message || error
						// this.$notice.show(`ERROR: ${error.message || error}`)
					})
			} else {
				this.userStore.loginRemote(fields)
					.then(res => {
						if (this.redirect) {
							this.$router.push({name: 'calculator'})
						}
					})
					.catch(error => {
						this.errorMessage = error.message || error
						// this.$notice.show(`ERROR: ${error.message || error}`)
					})
			}
		},
		resetPassword(fields) {
			this.errorMessage = null
			if (!fields.email) {
				return this.errorMessage = `Please enter email address.`
				// return this.$notice.show(`ERROR: Enter email address`)
			}
			this.userStore.resetPassword(fields)
				.then(res => {
					this.$notice.show(`Password reset email sent to: ${fields.email}`)
				})
		}
	},
}
</script>

<style scoped lang="scss">
</style>
